/*global http formHelper searchFilter news search*/
/*eslint-disable no-unused-vars*/
const pagination = {
	el: {
		paginationButtonPrev: document.querySelectorAll('.pagination__button--prev'),
		paginationButtonNext: document.querySelectorAll('.pagination__button--next')
	},

	vars: {
		maxPaginationItem: 5
	},

	fxPaginationItemHelper(response, element, currentPage) {
		if(Object.keys(response).length) {
			const data = response.data,
				pagination = data.pagination

			pagination.forEach(el => {
				if (el.currentPage) {
					if (el.page === 1)
						element.previousElementSibling.setAttribute('disabled', true)

					else if (el.page > 1 && pagination.length > 1)
						element.previousElementSibling.removeAttribute('disabled')

					if (el.page >= 1 && el.page < pagination.length)
						element.nextElementSibling.removeAttribute('disabled')

					else if (el.page === pagination.length)
						element.nextElementSibling.setAttribute('disabled', true)
				}
			})

			let start, end
			const ceiling = Math.ceil(this.vars.maxPaginationItem / 2),
				floor = Math.floor(this.vars.maxPaginationItem / 2)

			if (pagination.length < this.vars.maxPaginationItem) {
				start = 0
				end = pagination.length
			}
			else if (currentPage >= 1 && currentPage <= ceiling) {
				start = 0
				end = this.vars.maxPaginationItem
			}
			else if ((currentPage + floor) >= pagination.length) {
				start = pagination.length - this.vars.maxPaginationItem
				end = pagination.length
			}
			else {
				start = currentPage - ceiling
				end = currentPage + floor
			}

			for (let index = start; index < end + 1; index++) {
				element.querySelectorAll('.pagination__item')[index === 0 ? index : index - 1].classList.remove('is-hidden')
				element.querySelectorAll(`.pagination__item:nth-of-type(n+${end + 1})`).forEach(el => el.classList.add('is-hidden'))

				if (currentPage >= this.vars.maxPaginationItem - 1) {
					element.querySelectorAll(`.pagination__item:nth-of-type(-n+${start})`).forEach(el => el.classList.add('is-hidden'))
				}
			}
		}
	},

	fxPaginationHelper(response, element) {
		if(Object.keys(response).length) {
			const data = response.data,
				pagination = data.pagination

			element.innerHTML = ''

			element.style.pointerEvents = pagination.length === 1 ? 'none' : 'auto'

			pagination.forEach(el => {
				const isCurrentPage = el.currentPage ? 'is-active' : ''
				if (el.currentPage && el.page === 1)
					element.previousElementSibling.setAttribute('disabled', true)
				if (data.pagination.length === 1)
					element.nextElementSibling.setAttribute('disabled', true)

				element.innerHTML +=
					`
						<li class='pagination__item ${isCurrentPage}'>
							<button class='pagination__item-button'>${el.page}</button>
						</li>
					`
			})
		}
	},

	fxNavigationHelper(endpoint, selector, element, page, formElement) {
		const searchGeneral = element.closest('.search'),
			searchContainer = !element.offsetParent.querySelector('.js-get-news') ? (element.closest('.js-search') ? element.closest('.js-search') : element.closest('.modal').previousElementSibling.classList.contains('js-search')) : '',
			input = searchContainer ? searchContainer.querySelector('.js-autocomplete') : '',
			form = searchContainer.nextElementSibling && searchContainer.nextElementSibling.querySelector('.js-filter-modal') ? searchContainer.nextElementSibling.querySelector('.js-filter-modal') : formElement,
			value = input.value

		const callback = response => {
			this.fxPaginationHelper(response, element)

			if (element.offsetParent.querySelector('.js-get-news'))
				news.fxNewsCallback(response, selector)

			else if (searchGeneral)
				search.fxSearchCallback(response, page)

			else
				searchFilter.fxFilterCallback(response, formElement, page)
		}

		if (element.offsetParent.querySelector('.js-get-news'))
			http.fxGet(`${endpoint.substring(0, endpoint.lastIndexOf('/') + 1)}${page}`, callback).then(response => this.fxPaginationItemHelper(response, element, page))

		else if (searchGeneral)
			http.fxGet(`${endpoint.substring(0, endpoint.lastIndexOf('/') + 1)}${value}/${page}`, callback).then(response => this.fxPaginationItemHelper(response, element, page))

		else
			http.fxPost(`${endpoint.substring(0, endpoint.lastIndexOf('/') + 1)}${page}`, formHelper.fxFormToJson(form), callback).then(response => this.fxPaginationItemHelper(response, element, page))
	}
}